// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PBJa","footer":"styles_footer__vgQMb","passCodeTooltip":"styles_passCodeTooltip__2Mpn7"};